<template>
    <div>
        <div v-if="ajax_loader" class="checkoutLoader d-flex justify-center">
            <!-- <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div> -->
            <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
        </div>
        <div class="mb-3 scroll-new br-5">
            <div class="d-flex align-items-center justify-content-center bg-white" style="height: 400px;" v-if="ajaxCallInProgress">
                <!-- <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" style="left:170px" class="text-center w-100"/> -->
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
            <div v-else-if="allTickets.length == 0 && !ajaxCallInProgress" style="min-height: 493px;">
                <span class="fw-500 pl-25 pt-10" style="text-align: center !important; line-height:5">No Tickets Found!</span>
            </div>
            <div v-else v-for="(ticket, list_index) in allTickets" :key="list_index">
                <div class="list-box px-4 py-2 pointer" :class="{'list-light': list_index % 1, 'highlight' : list_id_index == list_index}" @click="ticketDetails(ticket, list_index)">
                    <div class="d-flex flex-wrap justify-content-between">
                        <span class="fs-14 font-weight-bold text-black-shade">Ticket ID: {{"#" +ticket.ticket_number}}</span>
                        <span class="text-black-shade fw-500 hide-line">{{ticket.created_date.replaceAll('-','/').replaceAll(' ',', ')}}</span>
                    </div>
                    <div class="pt-1 d-flex align-items-center flex-wrap justify-content-between">
                        <span class="fs-14 fw-600 text-black-shade" :title="ticket.subject" style="width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Subject: {{ticket.subject}}</span>
                        <button v-if="ticket.status" style="text-transform: capitalize;" class="btn btn-smm w-100px btn-default text-white btn-success-border-radius"
                            :class="{'btn-discarded': ticket.status == 'Discard',
                            'btn-open-status-newtheme':ticket.status == 'Open',
                            'btn-assigned':ticket.status == 'Assigned',
                            'btn-unassign':ticket.status == 'Unassigned',
                            'btn-grid-inprogress-newtheme':ticket.status == 'In progress',
                            'btn-fixed-newtheme':ticket.status == 'Fixed',
                            'btn-closed-newtheme':ticket.status == 'Closed', 
                            'btn-reopen-newtheme':ticket.status == 'Re-Open',
                            'btn-rejected':ticket.status == 'Reject', 
                            'btn-schedule':ticket.status == 'Scheduled',}">
                            <span v-if="ticket.status == 'In progress'">InProgress</span>
                            <span v-else-if="ticket.status == 'Re-Open'">Reopen</span>
                            <span v-else>{{ticket.status == 'Discard' ? 'Discarded' : ticket.status}}</span>
                        </button>
                    </div>
                    <div class="d-flex  justify-content-between pt-1">
                        <span class="text-black-shade fw-500 mr-2" v-if="ticket.template_type == 'default'" :title="ticket.assigned_to" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Assigned To: {{ticket.assigned_to || '-'}}</span>
                        <!-- <span class="text-black-shade fw-500 mr-2" v-if="ticket.template_type == 'multi_part'" :title="ticket.assigned_to" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Approver: {{ ticket.approve_data[0].name || '-' }}</span> -->
                        <span class="text-black-shade fw-500 mr-2" v-if="ticket.template_type == 'multi_part'"  style="max-width: 175px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                            Approvers: 
                            <span v-for="(approver, index) in ticket.approve_data" :key="approver.id" :title="ticket.approver">
                                {{ approver.name }}<span v-if="index < ticket.approve_data.length - 1">, </span>
                            </span>
                        </span>
                        <span class="text-black-shade fw-500 hide-line" :title="ticket.created_by" style="max-width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">Creator:  {{ticket.created_by || '-'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="display_filters" class="filters-background filterblock">
            <div class="scm-filters fadeInDown" :class="{'fadeInUp':hide_filters == true}">
                <filter-data @hideFilters="hideFilters" :showfilterData="showfilterData" @appliedFilter="appliedFilter"
                @showSuccessPopup="showSuccessPopup" @openSaveFilter="openSaveFilter"
                @showWarningPopup="showWarningPopup"></filter-data>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <filter-save-modal modal_name="save-filter" @filterSaved="filterSaved"></filter-save-modal>
    </div>
</template>
<script>
import { HollowDotsSpinner } from "epic-spinners";
import ticket from '../mixins/ticket.js';
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event.js';
import FilterSaveModal from "../ArchieveTickets/FilterSaveModal";
const FilterData = () => import('./FilterData')
const ChangeStatus = () => import("./ChangeStatus")
export default {
    components:{
        Swal,
        FilterData,
        FilterSaveModal,
        SweetModal,
        ChangeStatus,
        HollowDotsSpinner
    },
    mixins:[ticket],
    props:['active_tab', "getSkipCount", "display_filters", "hide_filters", "allTickets", "list_id_index", "ajaxCallInProgress", "showDetails", "showfilterData"],
    data(){
        return{
            passed_key: {
                key: 'created_date',
                value: -1
            },
            status_based_total: 0,
            search_key:'',
            search_key:'',
            count:0,
            ajaxCallInProgress:false,
            success_msg:'',
            warning_msg:'',
            selectedTicket:null,
            status:[],
            ticket_id:'',
            ticketStatus:'',
            showChange:false,
            closed_ticket:{},
            showfilterData:{
                created_templates: [],
                approvers: [],
                assigned_to:[],
                branch:[],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:'',
                created_tags: [],
                saveFilter: null
            },
            filterData:{
                created_templates: [],
                assigned_to:[],
                branch:[],
                approvers: [],
                company_name:[],
                created_date:[],
                department:[],
                last_modified_date:[],
                priority:[],
                product:[],
                status:[],
                ticket_number:[],
                template:[],
                behalf_selected:[],
                behalf_of_whom:'customer',
                assign_to_whom:'person',
                ticket_type:'',
                created_tags: [],
            },
            template_type: '',
            ajax_loader: false,
            save_filter_params: '',
            pageLimit: [],
            view_details: false
        }
    },
    methods:{
        openSaveFilter(filter_data){
            this.save_filter_params = {
                name: '',
                filters: filter_data
            }
            setTimeout(() => {
                this.$modal.show('save-filter');
            }, 500);
        },
        async filterSaved(value){
            try {
                this.save_filter_params.name = value
                let params = this.save_filter_params
                let res = await this.filterSave(params)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open()
                setTimeout(() => {
                    this.$refs.success_modal.close()
                }, 1000);
                setTimeout(() => {
                    EventBus.$emit('clear_selected_filter')
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open()
                setTimeout(() => {
                    this.$refs.warning_modal.close()
                }, 1000);
            }
        },
        cancelStatus(){
            this.showChange = false
        },
        hideFilters(){
            this.$emit('hideFilters')
        },
        updateStatus(){
            this.showChange = false;
            this.$emit('updateStatus')
        },
        showSuccessPopup(msg) {
            this.success_msg = msg;
            this.$refs.success_modal.open();
            setTimeout(() => {
                this.$refs.success_modal.close();
            }, 3000);
        },
        showWarningPopup(msg) {
            this.warning_msg = msg;
            this.$refs.warning_modal.open();
            setTimeout(() => {
                this.$refs.warning_modal.close();
            }, 3000);
        },
        appliedFilter(data){
            this.filterData = {
                created_templates: data.filterData.created_templates,
                created_tags: data.filterData.created_tags,
                assigned_to:data.filterData.assigned_to,
                approvers: data.filterData.approvers,
                branch:data.filterData.branch,
                company_name:data.filterData.company_name,
                created_date:data.filterData.created_date,
                department:data.filterData.department,
                last_modified_date:data.filterData.last_modified_date,
                priority:data.filterData.priority,
                product:data.filterData.product,
                status:data.filterData.status,
                ticket_number:data.filterData.ticket_number,
                template:data.filterData.template,
                assign_to_whom:data.filterData.assign_to_whom,
                behalf_of_whom:data.filterData.behalf_of_whom,
                behalf_selected:data.filterData.behalf_selected,
                ticket_type:data.filterData.ticket_type
            }
            this.showfilterData = {
                saveFilter: data.showfilterData.saveFilter,
                created_templates: data.showfilterData.created_templates,
                created_tags: data.showfilterData.created_tags,
                assigned_to:data.showfilterData.assigned_to,
                approvers: data.showfilterData.approvers,
                branch:data.showfilterData.branch,
                company_name:data.showfilterData.company_name,
                created_date:data.showfilterData.created_date,
                department:data.showfilterData.department,
                last_modified_date:data.showfilterData.last_modified_date,
                priority:data.showfilterData.priority,
                product:data.showfilterData.product,
                status:data.showfilterData.status,
                ticket_number:data.showfilterData.ticket_number,
                template:data.showfilterData.template,
                assign_to_whom:data.showfilterData.assign_to_whom,
                behalf_of_whom:data.showfilterData.behalf_of_whom,
                behalf_selected:data.showfilterData.behalf_selected,
                ticket_type:data.filterData.ticket_type
            }
            let filter = {
                filterData: this.filterData,
                showfilterData: this.showfilterData
            }
            this.$emit("appliedFilter", filter)
        },
        showAllStatus(ticket){
            this.ticket_id = ticket.ticket_id
            this.ticketStatus = ticket.status
            this.template_type = ticket.template_type
            this.closed_ticket = {
                ticket_number:ticket.ticket_number,
                company:ticket.company_name,
                subject:ticket.subject,
                author_name:ticket.created_by,
                assigned_to:ticket.assigned_to,
                description:ticket.description,
                ticket_id:ticket.ticket_id
            }
            this.showChange = true
            setTimeout(() => {
                this.$modal.show('status-change');
            }, 500);
        },
        ticketDetails(ticket, index){
            this.view_details = true
            this.$emit('setSelectedListIndex', index)
            let temp = []
            if(localStorage.getItem('listData')){
                temp = JSON.parse(localStorage.getItem('listData'))
                temp.unshift(ticket)
                temp = temp.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.ticket_number === value.ticket_number
                    ))
                )
                if(temp.length > 5){
                    temp.splice(temp.length - 1, 1)
                }
                localStorage.setItem('listData', JSON.stringify(temp));
            } else {
                temp.unshift(ticket)
                localStorage.setItem('listData', JSON.stringify(temp));
            }
            this.$emit('updateTabsForList')
            // EventBus.$emit('viewDetails', ticket)
        },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
        },
        createTickets() {
            let ticket ={
                ticket_id:'',
                ticket_number:''
            }
            localStorage.setItem("parentTicketDetails", JSON.stringify(ticket))
            this.$router.push({ name: "TicketsCreate" });
        },
        ticketDelete(ticket){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to archieve" + ' ' + JSON.stringify(ticket.ticket_number) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        ticket_id:ticket.ticket_id
                    }
                    this.confirmDelete(params)
                }
            })
        },
        async confirmDelete(params){
            try {
                this.ajax_loader = true
                let res = await this.deleteTicket(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.ajax_loader = false
                    EventBus.$emit('RecallStatusTabs')
                    this.$emit('ResetOnArchival')
                }, 3000);
            } catch (reason) {
                this.ajax_loader = false
                this.warning_msg = 'Only Closed Tickets can be Archived'
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    },
    async mounted(){
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        if(localStorage.getItem('StoreFilterData')){
            let FilterData = JSON.parse(localStorage.getItem('StoreFilterData'));
            this.showfilterData = FilterData.showfilterData;
            this.filterData = FilterData.filterData;
        }
        EventBus.$on('updateTableView',status=>{
            if(status.is_tab_selected){
                this.filterData.status = status.status_tab
            }
            if(status.dashboard_filter){
                this.filterData.created_tags = status.dashboard_filter.filterData.created_tags,
                this.filterData.created_templates = status.dashboard_filter.filterData.created_templates,
                this.showfilterData.created_tags = status.dashboard_filter.showfilterData.created_tags,
                this.showfilterData.created_templates = status.dashboard_filter.showfilterData.created_templates
            }
        })
        EventBus.$on('updateTableViewTab',status =>{
            this.view_details = true
            let newData = {
                filterData: this.filterData,
                showfilterData: this.showfilterData
            }
            localStorage.setItem("StoreFilterData", JSON.stringify(newData))
        })
    },
    destroyed(){
        EventBus.$off('updateTableViewTab');
        EventBus.$off('updateTableView');
    }
}
</script>
<style scoped>

.table-new-template tbody tr td{
    width: 10% !important;
}
.scm-filters {
    font-family: "Poppins", "Helvetica Neue", sans-serif !important;
    height: 500px;
    overflow: auto;
    max-width: 768px;
    top: 135px;
    /* background: #e6ecff !important; */
    position: fixed;
}
.mw-200px{
    min-width: 200px !important;
}
.overflow-visible{
    overflow: scroll !important;
    z-index: 9999 !important;
    right: 19px !important;
    width: 650px;
}
.ht-100px{
    height: 100px;
}
.inverse div{
     position: absolute;
     top: 27px;
     width: 11px;
     height: 11px;
     border-radius: 50%;
     background: #005dae;
     animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
span.caps::first-letter{
    text-transform: uppercase !important;
}
.list-light {
    width: 100%;
    object-fit: contain;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f3f6fb;
    background-color: #ffffff;
}
.text-black{
    color: #363636 !important;
}
.highlight{
    background-color: #d5e2fa !important;
}
.btn-discarded{ 
    background-image: linear-gradient(to bottom, #9fc8f4, #3883d5) !important;  
    color: #130e0e !important
}
@media (max-width: 1100px) {
    .hide-line{
        display: none;
    }
}
/* 
.text-open-status{
    color: #FD7372 !important;
}
.text-inprogress-status{
    color: #2E5EF5 !important
}
.text-fixed-status{
    color: #27B88F !important;
}
.text-closed-status{
    color: #FF9134 !important;
}
.text-reopen-status{
    color: #E4A741 !important
} */
</style>